import {
  type getGetBackAttivitaIdComunicazioniAllegatiIdQueryOptions,
  type getGetBackProcedimentiIdComunicazioniAllegatiIdQueryOptions,
} from '@framework/api-client/api/backoffice/comunicazioni-inalterate/comunicazioni-inalterate.ts';
import { type getGetFrontComunicazioniAllegatiIdQueryOptions } from '@framework/api-client/api/inquiries-compile/comunicazioni-inalterate/comunicazioni-inalterate.ts';
import { type AllegatoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoComunicazioneDTO.ts';
import { useAuthDownload } from '../../../../utils/download/useAuthDownload.ts';
import { useCommunicationsContext } from '../../context/CommunicationsContext.tsx';

export type IGetCommunicationAttachmentQueryOptions =
  | typeof getGetBackAttivitaIdComunicazioniAllegatiIdQueryOptions
  | typeof getGetBackProcedimentiIdComunicazioniAllegatiIdQueryOptions
  | typeof getGetFrontComunicazioniAllegatiIdQueryOptions;

interface IProps {
  attachment: AllegatoComunicazioneDTO | null | undefined;
  hasInlineViewer?: boolean;
}

// TODO
export function useCommunicationAttachments(props: IProps) {
  const { attachment, hasInlineViewer } = props;

  const {
    submissionId,
    procedureId,
    taskId,
    getDownloadAttachmentQueryOptions: getCommunicationAttachmentQueryOptions,
  } = useCommunicationsContext();

  const backofficeEntityId = taskId ?? procedureId;

  const { download, isFetching } = useAuthDownload(
    getCommunicationAttachmentQueryOptions,
    // Se c'è il submissionId sono frontoffice, quindi serve solo l'ID dell'allegato
    submissionId
      ? [attachment?.id ?? '<unknown>']
      : // Altrimenti sono backoffice e serve anche l'ID dell'entità
        [backofficeEntityId ?? '<unknown>', attachment?.id ?? '<unknown>'],
    {
      filename: attachment?.nomeFile,
      showInlineViewer: hasInlineViewer,
      queryOptions: { enabled: !!attachment?.id },
    },
  );

  return { download, isFetching };
}
